import { relation, children, text } from '@nozbe/watermelondb/decorators';
import { COMPANY } from '../schema';
import { Model } from '@nozbe/watermelondb';

export default class Company extends Model {
    static table = COMPANY;

    static associations = {
        business: { type: 'belongs_to', key: 'business_id' },
        invoice: { type: "has_many", foreignKey: "company_id" },
    }

    @text('name') name;

    @relation('business', 'business_id') business;

    @children("invoice") invoice;

};